import { motion } from "framer-motion";

const HeroSection = () => {
    return (
        <section className="w-full">
            {/* <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="bg-white text-center md:mt-20 mt-16 md:py-6 py-2 px-6"
            >
                <motion.h1
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
                    viewport={{ once: true }}
                    className="text-2xl md:text-5xl font-semibold text-gray-900 leading-tight"
                >
                    Premium Custom Paint Services
                    <br />
                    Designed for Your Style
                </motion.h1>

                <motion.p
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
                    viewport={{ once: true }}
                    className="mt-6 max-w-3xl mx-auto text-gray-600 text-sm md:text-base"
                >
                    We specialise in high-quality custom paint jobs tailored to your exact preferences. Whether you're restoring your vehicle, changing color, or enhancing gloss levels, our paint solutions are built to last in India’s demanding weather conditions.                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.6, ease: "easeOut" }}
                    viewport={{ once: true }}
                    className="mt-8 flex justify-center gap-4"
                >
                    <motion.button
                        whileHover={{
                            scale: 1.05,
                            boxShadow: "0 10px 25px -5px rgba(220, 38, 38, 0.3)"
                        }}
                        whileTap={{ scale: 0.95 }}
                        className="bg-red-600 text-white md:px-6 px-2 md:py-3 py-1 text-sm font-medium rounded hover:bg-red-700 transition-all"
                    >
                        Request Paint Consultation          </motion.button>

                  
                </motion.div>
            </motion.div> */}

            <div className="w-full">
                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 1.2 }}
                    viewport={{ once: true }}
                    className="relative  shadow-2xl"
                >
                    <img
                        src="/assets/paint/hero.jpg"
                        alt="Luxury Car"
                        className="w-full h-[220px] md:h-[650px] lg:h-[100vh] object-cover object-center"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                </motion.div>
            </div>
        </section>
    );
};

export default HeroSection;